import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const Section = ({ title, subtitle, children }) => {
  const theme = useTheme();
  return (
    <Box>
      <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
      <Typography
        variant="body2"
        sx={{ color: theme.customColors.text.secondary, mb: 2 }}
      >
        {subtitle}
      </Typography>
      <Stack spacing={2}>{children}</Stack>
    </Box>
  );
};
